import React from 'react';
import { PhoneIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-tlfc-dark" data-id="element-200">
      {/* Background Image — Melbourne Cityscape */}
      <div className="absolute inset-0" data-id="element-201">
        <img src="https://images.unsplash.com/photo-1514395462725-fb4566210144?w=1920&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" data-id="element-202" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-tlfc-dark/75" data-id="element-203" />
        {/* Gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-t from-tlfc-dark via-tlfc-dark/50 to-transparent" data-id="element-204" />
        {/* Warm accent glow */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_100%,rgba(184,148,79,0.08),transparent)]" data-id="element-205" />
      </div>

      {/* Subtle Animated Grid */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-206">
        <defs data-id="element-207">
          <pattern id="hero-grid" width="80" height="80" patternUnits="userSpaceOnUse" data-id="element-208">
            <path d="M 80 0 L 0 0 0 80" fill="none" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" className="grid-pulse" data-id="element-209" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hero-grid)" data-id="element-210" />
      </svg>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 pt-28 pb-20 text-center" data-id="element-211">
        <div className="max-w-4xl mx-auto" data-id="element-212">
          {/* Eyebrow */}
          <p className="reveal text-xs uppercase tracking-wider text-tlfc-gold font-medium" data-id="element-213">
            Melbourne's Trusted Legal Team
          </p>

          {/* Headline */}
          <h1 className="reveal reveal-delay-1 mt-6 font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-medium text-tlfc-white leading-[1.1] tracking-tight text-balance" data-id="element-214">
            When the stakes are high, you need certainty.
          </h1>

          {/* Subhead */}
          <p className="reveal reveal-delay-2 mt-6 text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-215">
            Accredited specialists in business, property, litigation, family and
            employment law — delivering clarity and results for over 50 years.
          </p>

          {/* CTA Row */}
          <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-216">
            <a href="#contact" className="inline-flex items-center gap-2 px-8 py-4 bg-tlfc-gold text-white font-medium text-base rounded-lg hover:bg-tlfc-gold-light transition-all duration-300 shadow-gold group" data-id="element-217">
              Talk to a specialist
              <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-218" />
            </a>
            <a href="#matters" className="inline-flex items-center gap-2 px-8 py-4 border border-white/30 text-white font-medium text-base rounded-lg hover:bg-white/10 hover:border-white/50 transition-all duration-300" data-id="element-219">
              How we can help
            </a>
          </div>

          {/* Phone Number */}
          <a href="tel:0386009333" className="reveal reveal-delay-4 inline-flex items-center gap-2 mt-8 text-white/70 hover:text-white transition-colors" data-id="element-220">
            <PhoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-221" />
            <span className="text-sm" data-id="element-222">(03) 8600 9333</span>
          </a>

          {/* Trust Strip */}
          <div className="reveal reveal-delay-5 mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-8" data-id="element-223">
            <span className="inline-flex items-center gap-2 text-sm text-white/60" data-id="element-224">
              <CheckCircleIcon className="w-4 h-4 text-tlfc-gold" aria-hidden="true" data-id="element-225" />
              Recognised in Doyle's Guide
            </span>
            <span className="inline-flex items-center gap-2 text-sm text-white/60" data-id="element-226">
              <CheckCircleIcon className="w-4 h-4 text-tlfc-gold" aria-hidden="true" data-id="element-227" />
              Best Law Firms – Australia
            </span>
            <span className="inline-flex items-center gap-2 text-sm text-white/60" data-id="element-228">
              <CheckCircleIcon className="w-4 h-4 text-tlfc-gold" aria-hidden="true" data-id="element-229" />
              Accredited Specialists
            </span>
          </div>
        </div>
      </div>
    </section>;
}